import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import Home from './components/home/home.vue'
import Overons from './components/overons/overons.vue'
import Portfolio from './components/portfolio/portfolio.vue'
import Contact from './components/contact/contact.vue'
import NotFound from './components/shared/404.vue'

Vue.use(VueRouter);

const routes = [
  { path: '*',            redirect: '/404' },
  { path: '/404',         component: NotFound, meta:{title: '404 | Jvdw',  requiresAuth: true }},
  { path: '',             component: Home,
  meta:{
    title: 'Home | Jvdw',
    metaTags: [
        {
          name: 'description',
          content: 'J. van den wijngaart schilders behangers.'
        },
        {
          property: 'og:title',
          content: 'J. van den Wijngaart, schilders en behangers.'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:image',
          content: 'https://geo1.ggpht.com/cbk?panoid=V2YKKrR2v-6w1_ifTfB3Ig&output=thumbnail&cb_client=search.gws-prod%2Flocal-details-localweb.gps&thumb=2&yaw=216.44887&pitch=0&thumbfov=100&w=139&h=160'
        },
        {
          property: 'og:url',
          content: 'https://jvdwijngaart.nl'
        },
        {
          property: 'og:description',
          content: 'J. van den wijngaart schilders behangers gevestigd in Uithoorn.'
        }
      ]
  }},
  { path: '/over',        component: Overons,
  meta:{
    title:      'Over Ons | Jvdw',
    metaTags: [
        {
          name: 'description',
          content: 'The about page of our example app.'
        },
        {
          property: 'og:description',
          content: 'The about page of our example app.'
        }
      ]
  }},
  { path: '/portfolio',   component: Portfolio,
  meta:{
    title:     'Portfolio | Jvdw',
    metaTags: [
        {
          name: 'description',
          content: 'The about page of our example app.'
        },
        {
          property: 'og:description',
          content: 'The about page of our example app.'
        }
      ]
  }},
  { path: '/contact',     component: Contact,
  meta:{
    title:       'Contact | Jvdw',
    metaTags: [
        {
          name: 'description',
          content: 'The about page of our example app.'
        },
        {
          property: 'og:description',
          content: 'The about page of our example app.'
        }
      ]
  }}
];

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    if (!nearestWithMeta) return next();
    nearestWithMeta.meta.metaTags.map(tagDef => {
            const tag = document.createElement('meta');
            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key]);
            });
            tag.setAttribute('data-vue-router-controlled', '');
            return tag;
        })
        .forEach(tag => document.head.appendChild(tag));
    next();
});

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
}).$mount('#app')
